<template>
  <div
    :style="boxStyle"
    class="input-wrapper bg-primary-white"
    :class="{
      active: props.active,
      error: props.error,
    }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
  import { defineProps, computed } from 'vue'

  interface Props {
    active?: boolean
    border?: string
    borderActive?: string
    borderRadius?: string
    background?: string
    padding?: string
    boxShadow?: string
    boxShadowActive?: string
    width?: string
    height?: string
    outline?: string
    error?: string
  }

  const props = defineProps<Props>()

  const boxStyle = computed(() => {
    return {
      border: props.active ? props.borderActive : props.border,
      borderRadius: props.borderRadius,
      background: props.background,
      padding: props.padding,
      width: props.width,
      height: props.height,
      boxShadow: props.active ? props.boxShadowActive : props.boxShadow,
      outline: props.outline,
    }
  })
</script>

<style scoped>
  .input-wrapper {
    outline: 1px solid #dee2e6;
    border-radius: var(--border-radius-default);
    padding: 0px;
    box-shadow: none;
    height: 100%;
    width: 100%;
  }

  .input-wrapper.error {
    outline: 1px solid var(--primary-orange);
  }

  .input-wrapper.active {
    outline: 2px solid var(--primary-blue);
    box-shadow:
      0px 0px 0px 6px var(--blue-100),
      0px 0px 0px 4px rgba(0, 0, 0, 0.25);
  }
</style>
